import { connect } from "react-redux";
import TicketDetails from "./ticketDetails";
import { bindActionCreators } from "redux";
import { getTicketDetails, repliesOnTicket, getStatusList, changeStatus } from "services/redux/tickets/ticketDetails/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  ticketDetails: state.ticketDetailsReducer.ticketDetails,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  statusList: state.ticketDetailsReducer.statusList, 
  changeStatus: state.ticketDetailsReducer.changeStatus,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getTicketDetails,
    documentUploadUrl,
    repliesOnTicket,
    changeStatus,
    getStatusList,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TicketDetails);
